/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DescribeCompanyRequest
 */
export interface DescribeCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof DescribeCompanyRequest
     */
    guid: string;
}

/**
 * Check if a given object implements the DescribeCompanyRequest interface.
 */
export function instanceOfDescribeCompanyRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "guid" in value;

    return isInstance;
}

export function DescribeCompanyRequestFromJSON(json: any): DescribeCompanyRequest {
    return DescribeCompanyRequestFromJSONTyped(json, false);
}

export function DescribeCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescribeCompanyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'guid': json['guid'],
    };
}

export function DescribeCompanyRequestToJSON(value?: DescribeCompanyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'guid': value.guid,
    };
}

